import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showDetails: {
		id: 'issue-field-cmdb-object.card.show-details',
		defaultMessage: 'Show details',
		description: 'Label/Tooltip for button icon that shows details for a CMDB object field',
	},
	showLessDetails: {
		id: 'issue-field-cmdb-object.card.show-less-details',
		defaultMessage: 'Show less details',
		description: 'Label/Tooltip for button icon that hides details for a CMDB object field',
	},
	viewFullObjectDetails: {
		id: 'issue-field-cmdb-object.card.view-full-object-details',
		defaultMessage: 'View full object details & graph',
		description: 'Button to open a dialog containing complete details about a CMDB object',
	},
	deleteObject: {
		id: 'issue-field-cmdb-object.card.delete-object',
		defaultMessage: 'Remove object',
		description: 'Label for button to delete a CMDB object',
	},
	noSchemaPermission: {
		id: 'issue-field-cmdb-object.card.no-schema-permission',
		defaultMessage: 'You do not have the required permissions to view full object details',
		description:
			'Label/Tooltip for icon that indicates the user cannot access the object graph as they do not have required permissions',
	},
	loadingPermissions: {
		id: 'issue-field-cmdb-object.card.loading-permissions',
		defaultMessage: 'Loading…',
		description:
			'Label/Tooltip for icon that shows while checking if ther user has permission to access the object graph',
	},
});
